export const educationData = [
    {
        id: 1,
        institution: 'Purdue University',
        course: 'Masters in Business Analytics and Information Technology',
        startYear: '2023',
        endYear: 'Present'
    },
    {
        id: 2,
        institution: 'National Institute of Technology, Warangal',
        course: 'Bachelor of Technology in Chemical Engineering',
        startYear: '2016',
        endYear: '2020'
    },
]